import { render, staticRenderFns } from "./ResolveOrder.vue?vue&type=template&id=060e2f0a&scoped=true&"
import script from "./ResolveOrder.vue?vue&type=script&lang=js&"
export * from "./ResolveOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060e2f0a",
  null
  
)

export default component.exports